import React from 'react';
import { logClientError } from '@/utils/logger';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  resetKey?: string | number | null;
}

interface State {
  hasError: boolean;
  error?: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logClientError(error, info);
  }

  componentDidUpdate(prevProps: Props) {
    // reset when resetKey changes
    if (this.props.resetKey !== prevProps.resetKey && this.state.hasError) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return <>{this.props.fallback}</>;
      return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-50">
          <div className="bg-white p-6 rounded-md shadow-md max-w-lg w-full">
            <h2 className="text-lg font-semibold mb-2">發生錯誤</h2>
            <p className="text-sm text-gray-600 mb-4">抱歉，我們遇到意外錯誤，請稍後再試或重新整理頁面。</p>
            <div className="flex gap-2">
              <button
                className="px-4 py-2 rounded bg-blue-600 text-white"
                onClick={() => window.location.reload()}
              >
                重新整理
              </button>
            </div>
          </div>
        </div>
      );
    }

    return <>{this.props.children}</>;
  }
}
